import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex h-full w-full flex-1 flex-col items-center justify-center"
}
const _hoisted_2 = { class: "text-xl font-bold" }
const _hoisted_3 = { class: "text-muted-foreground" }

import { computed, ref, watch } from 'vue';
    import axios from 'axios';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { PowerBIReportEmbed } from 'powerbi-client-vue-js';
    import { usePowerBiData } from '@/composables/usePowerBiData';
    import { toast } from 'vue-sonner';
    import PowerBIOriginal from '@/components/icons/PowerBIOriginal.vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PowerBI',
  setup(__props) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);
    const { t } = useI18n();

    const {
        powerBiData,
        isPowerBiPending,
        isPowerBiFetching,
        isPowerBiSuccess,
        isPowerBiDataError,
        powerBiDataError,
    } = usePowerBiData(selectedCompanyId.value);

    watch(powerBiDataError, (error: any) => {
        if (error) {
            toast.error(error?.response?.data?.error || t('power_bi.error_fetching_power_bi_data'));
        }
    });

    const embedUrl = computed(() => {
        return `https://app.powerbi.com/reportEmbed?reportId=${powerBiData.value.report_id}&groupId=${powerBiData.value.group_id}`;
    });

return (_ctx: any,_cache: any) => {
  return (_unref(powerBiData) && _unref(powerBiData).report_id)
    ? (_openBlock(), _createBlock(_unref(PowerBIReportEmbed), {
        key: 0,
        embedConfig: {
            type: 'report',
            id: _unref(powerBiData).report_id,
            embedUrl: embedUrl.value,
            accessToken: _unref(powerBiData).access_token,
            tokenType: 1,
            settings: {
                panes: {
                    filters: {
                        expanded: false,
                        visible: false,
                    },
                },
                background: 0,
            },
        },
        cssClassName: "powerbi-embed",
        phasedEmbedding: false,
        eventHandlers: 
            new Map([
                ['loaded', () => console.log('Report loaded')],
                ['rendered', () => console.log('Report rendered')],
                ['error', (event) => console.log(event)],
            ])
        
      }, null, 8, ["embedConfig", "eventHandlers"]))
    : (!_unref(isPowerBiFetching))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(PowerBIOriginal, { className: "size-12 mb-4" }),
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('power_bi.no_power_bi_data_found')), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('power_bi.please_contact_support')), 1)
        ]))
      : _createCommentVNode("", true)
}
}

})